import './style.scss'
import { ReactComponent as Star } from 'assets/icons/trastpilot/trustpilot-star.svg'

const starsCount = ({ size }) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
        stars.push(
            <div key={i} className={`trastpilot-rate__star trastpilot-rate__star--${size}`}>
                <Star />
            </div>
        );
    }
    return stars;
};

//size: M/L

const TrastpilotStars = ({ size = "M" }) => {

    return (
        <div className='trastpilot-rate'>
            {starsCount({ size })}
        </div >
    );
}

export default TrastpilotStars;